exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tile-editor{flex-grow:1;display:flex;flex-direction:column;align-items:center;height:100%}.tile-editor .editor-section{align-self:stretch;flex-grow:1;display:flex;flex-direction:row;height:10%}.tile-editor .data-section{align-self:stretch;height:256px;background-color:#101012}", ""]);

